import React, { useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  // Input,
  Tooltip,
  ModalFooter,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import { Col, Row } from "reactstrap";
import {
  SuccessfullyMessageBarDispatch,
  ToastContextDispatch,
} from "Context/CommonContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  BASE_URL,
  STUDENT_SEARCH,
  MARK_STUDENT_ISSUE_REPORT,
} from "utilFunctions/Constants/urlConstants";
import AutoSearchInput from "utilFunctions/shared/AutoSearchInput";
import ReportLog from "./ReportLogo.svg";
import { UserInfoContext } from "Context/CommonContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import InfoIcon from "Assets/Icons/InfoIcon";
import "./index.css";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { TextAreaInput } from "Components/InputComponents/TextAreaInput";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DraggableModal from "utilFunctions/shared/DraggableModal";
import CustomSelect from "Components/CommonComponents/CustomSelect";

const IssueType: any = [
  {
    label: "Student not present in batch list",
    value: "Student not present in batch list",
  },
];
interface ReportStudentAttendance {
  selectedSchedule: any;
  isModalOpen: boolean;
  setIsModalOpen: any;
  handleReportedStudentList?: any;
}

const ReportStudentAttendance: React.FC<ReportStudentAttendance> = ({
  selectedSchedule,
  isModalOpen,
  setIsModalOpen,
  handleReportedStudentList,
}) => {
  const [input, setInput] = useState("");
  const successMessageInfor = useContext<any>(SuccessfullyMessageBarDispatch);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [inputValue, setInputValue] = useState<any>();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [offset, setOffSet] = useState<number>(0);
  const [suggestions, setSuggestions] = useState<any>([]);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const fieldA = {
    label: "Student not present in batch list",
    value: "Student not present in batch list",
  };
  const [comment, setComment] = useState("");
  const [selectedStudent, setSelectedStudent] = useState<any>(null);
  const [attendanceMode, setAttendanceMode] = useState("");
  const [errors, setErrors] = useState<{
    fieldB?: string;
    comment?: string;
    attendanceMode?: string;
    selectedStudent?: string;
  }>({});
  const [searchURL, setSearchURL] = useState<string>("");
  const [searchName, setSearchName] = useState<any>();
  const [limit] = useState<number>(10);
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { screen }: any = useWindowSize();

  const infoToggle = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const closeModal = () => {
    resetForm();
    setIsModalOpen(false);
  };

  const resetForm = () => {
    setComment("");
    setErrors({});
    setAttendanceMode("");
    setSelectedStudent(null);
    setInput("");
    setSuggestions([]);
  };

  const handleSetInputValue = (val: string) => {
    setInputValue(val);
    setOffSet(0);
  };

  const nextHandler = () => {
    const newOffset = offset + limit;
    setOffSet((previous) => previous + limit);
    const url = searchURL + "&limit=" + limit + "&offset=" + newOffset;
    GetSearchData(url);
  };

  const onFetcheddata = (data: any) => {
    setIsLoader(false);
    console.log(data);
  };
  const onFetchError = (error: any) => {
    console.log("erorr", error);
    setIsLoader(false);
    if (offset == 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
    setHasMore(false);
  };

  const { makeRequest: GetSearchData, responseData: searchData } = useGetApi(
    (data) => {
      onFetcheddata(data);
    },
    (error) => {
      onFetchError(error);
    }
  );

  useEffect(() => {
    if (searchData && searchData != null) {
      if (offset == 0) {
        setSuggestions([...searchData["data"]]);
      } else {
        setSuggestions((previous: any) => [...previous, ...searchData["data"]]);
      }
      setHasMore(
        searchData["data"] && searchData["data"].length > 0 ? true : false
      );
    }
  }, [searchData]);

  const { makeRequest: PostStudentIssueReport } = usePutPostAPI(
    (data: any) => {
      if (data && data["data"]) {
        successMessageInfor({
          message: `Issue reported for ${selectedStudent?.name}.`,
          isShow: true,
        });
        const psidlength = 11 - parseInt(selectedStudent?.psid.length);
        let newPSID = selectedStudent?.psid;
        if (psidlength == 0) {
          newPSID = selectedStudent?.psid;
        } else {
          for (let i = 0; i < psidlength; i++) {
            newPSID = 0 + newPSID;
          }
        }
        handleReportedStudentList([
          {
            studentName: selectedStudent.name,
            psid: newPSID,
            attendanceType: attendanceMode,
            hasFlag: true,
          },
        ]);
        closeModal();
      }
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message:
          error["response"]["data"]["code"] ||
          error["response"]["data"]["message"],
      });
    },
    "POST"
  );

  const handleSave = () => {
    const newErrors: {
      comment?: string;
      attendanceMode?: string;
      selectedStudent?: string;
    } = {};

    if (attendanceMode === "") {
      newErrors.attendanceMode = "Attendance Mode required";
    }
    if (selectedStudent === null || selectedStudent === undefined) {
      newErrors.selectedStudent = "Student required";
    }

    if (comment && comment.length > 500) {
      newErrors.comment = "Comment must not exceed 500 characters";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const postRequestObject = {
      batch_id: selectedSchedule?.batchId,
      lectureId: selectedSchedule?.batchTimeTableId,
      facultyId: userInfo?.employeeId,
      room: selectedSchedule?.room,
      className: selectedSchedule?.class,
      branchId: selectedSchedule?.branchId,
      remarks: comment,
      // captureTime: Date.now(),
      studentsAttendance: [
        {
          psid: selectedStudent?.psid,
          attendanceType: attendanceMode,
        },
      ],
      scheduledStartDate: selectedSchedule?.startTime,
      scheduledEndDate: selectedSchedule?.endTime,
    };
    const url = BASE_URL + MARK_STUDENT_ISSUE_REPORT;
    PostStudentIssueReport(url, postRequestObject);
  };

  const hasNumbers = (t: any) => {
    const regex = /\d/g;
    return regex.test(t);
  };

  const searchDataHandler = (searchterm: any) => {
    let url = `${BASE_URL + STUDENT_SEARCH}`;

    if (hasNumbers(searchterm)) {
      url = url + `psid=${searchterm}&isReportIssue=true&`;
      // url = url + `psid=${searchterm}`;
    } else {
      url = url + `name=${searchterm}`;
    }
    setSearchURL(url);
    // GetSearchData(url);
    const newUrl = url + "&limit=" + limit + "&offset=" + offset;
    GetSearchData(newUrl);
  };

  const formComponent = () => {
    return (
      <div className="report-form-container-style">
        <FormGroup className="form-item-style">
          <div className="d-flex w-100 d-flex flex-row align-items-center">
            <span className="issueTypeStudent">Issue Type</span>
            <InfoIcon id={"Tooltip-student-attendance-report"}></InfoIcon>
            <Tooltip
              placement={"bottom"}
              isOpen={tooltipOpen}
              target={"Tooltip-student-attendance-report"}
              toggle={infoToggle}
            >
              {"Issue Type"}
            </Tooltip>
          </div>
          <CustomSelect
            width={"100%"}
            top={"-3px"}
            placeholder="Select Issue type"
            options={IssueType}
            isSearchable={false}
            menuPlacement="bottom"
            isClearable={false}
            menuShouldScrollIntoView={true}
            closeMenuOnSelect={true}
            disabled={true}
            className="input-report-style"
            // onChange={(selected: any) => {
            //   handleAddFilterArrayList("stream", selected);
            // }}
            value={fieldA}
          />
          {/* <Input
            type="text"
            id="fieldA"
            value={fieldA}
            disabled
            className="input-report-style"
          /> */}
        </FormGroup>
        <FormGroup className="form-item-style">
          <Label className="issueTypeStudent" for="selectedStudent">
            Student Name/PSID<span className="mandatory">*</span>
          </Label>
          <AutoSearchInput
            setInputValue={(val: string) => handleSetInputValue(val)}
            setSuggestions={setSuggestions}
            suggestions={suggestions}
            isLoader={isLoader}
            setIsLoader={setIsLoader}
            searchData={searchDataHandler}
            searchName={searchName}
            setSearchName={setSearchName}
            placeholder="Search by student name or PSID"
            nextHandler={nextHandler}
            hasMore={hasMore}
            input={input}
            setInput={setInput}
            routeDisabled={true}
            mode={"studentIssue"}
            setSelectedStudent={setSelectedStudent}
          />
          {errors.selectedStudent && (
            <div className="text-danger">{errors.selectedStudent}</div>
          )}
        </FormGroup>
        <FormGroup className="form-item-style">
          <Label className="issueTypeStudent" for="attendanceMode">
            Student Attendance<span className="mandatory">*</span>
          </Label>
          <div>
            <Row>
              <Col>
                <button
                  type="button"
                  className={
                    attendanceMode == "A"
                      ? "btn custom-width-report-btn custom-present-btn"
                      : "btn custom-width-report-btn prsent-hover-button btn-outline-aeslDraft"
                  }
                  onClick={() => {
                    setAttendanceMode("A");
                    //handleStudentStatus(cardData, "A");
                  }}
                >
                  {"Present"}
                </button>
              </Col>
              <Col className="p-0">
                <button
                  type="button"
                  className={
                    attendanceMode == "O"
                      ? "btn custom-width-report-btn custom-online-btn"
                      : "btn custom-width-report-btn online-hover-button btn-outline-aeslDraft"
                  }
                  onClick={() => {
                    setAttendanceMode("O");
                    //handleStudentStatus(cardData, "A");
                  }}
                >
                  {"Online"}
                </button>
              </Col>
              <Col></Col>
            </Row>
            {errors.attendanceMode && (
              <div className="text-danger">{errors.attendanceMode}</div>
            )}
          </div>
        </FormGroup>
        <FormGroup className="form-item-style-comment">
          <Label className="issueTypeStudent" for="comment">
            Add Comment
          </Label>
          <TextAreaInput
            label=""
            id="description"
            name={"description"}
            onChange={(e) => setComment(e.target.value)}
            className="textAreaStudentReport"
            placeholder="Comment"
          />
          {errors.comment && (
            <div className="text-danger">{errors.comment}</div>
          )}
        </FormGroup>
      </div>
    );
  };

  return (
    <div>
      {["xxl", "xl", "lg"].includes(screen) ? (
        <Modal isOpen={isModalOpen} toggle={closeModal} size="sm" centered>
          <ModalHeader toggle={closeModal}>
            <div className="d-flex flex-row align-items-center">
              <img src={ReportLog} />
              <span style={{ color: "#333333", marginLeft: "8px" }}>
                {" Report Issue"}
              </span>
            </div>
          </ModalHeader>
          <ModalBody>{formComponent()}</ModalBody>
          <ModalFooter>
            <div className="w-100 pb-2 pl-2 pr-2">
              <Button
                disabled={
                  selectedStudent === null ||
                  attendanceMode == "" ||
                  inputValue === ""
                    ? true
                    : false
                }
                color={
                  selectedStudent === null ||
                  attendanceMode == "" ||
                  inputValue === ""
                    ? "aeslDraft"
                    : "aeslPrimary"
                }
                onClick={handleSave}
                block
              >
                Save
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      ) : (
        <DraggableModal
          initHeight={550}
          isPaneOpen={isModalOpen}
          togglePane={closeModal}
        >
          <div>
            <ModalHeader toggle={closeModal} style={{ fontSize: "20px" }}>
              <div className="d-flex flex-row align-items-center">
                <img src={ReportLog} />
                <span
                  style={{
                    color: "#333333",
                    marginLeft: "8px",
                    fontSize: "20px",
                  }}
                >
                  {" Report Issue"}
                </span>
              </div>
            </ModalHeader>
            <div className="studentReportMb">
              {formComponent()}
              <Button
                disabled={
                  selectedStudent === null ||
                  attendanceMode == "" ||
                  inputValue === ""
                    ? true
                    : false
                }
                color={
                  selectedStudent === null ||
                  attendanceMode == "" ||
                  inputValue === ""
                    ? "aeslDraft"
                    : "aeslPrimary"
                }
                onClick={handleSave}
                block
              >
                Save
              </Button>
            </div>
          </div>
        </DraggableModal>
      )}
    </div>
  );
};

export default ReportStudentAttendance;
